import { GlIcon, GlPopover, GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { n__, sprintf } from '~/locale';
import { HEALTH_STATUS_AT_RISK, HEALTH_STATUS_NEEDS_ATTENTION, HEALTH_STATUS_ON_TRACK } from 'ee/sidebar/constants';
export default {
    name: 'WorkItemRolledUpHealthStatus',
    components: {
        GlIcon,
        GlPopover,
        GlSprintf
    },
    props: {
        rolledUpHealthStatus: {
            type: Array,
            required: true
        },
        healthStatusVisible: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        rolledUpOnTrackWorkItems () {
            return this.rolledUpHealthStatus?.find((status)=>status.healthStatus === HEALTH_STATUS_ON_TRACK);
        },
        rolledUpAtRiskWorkItems () {
            return this.rolledUpHealthStatus?.find((status)=>status.healthStatus === HEALTH_STATUS_AT_RISK);
        },
        rolledUpNeedsAttentionWorkItems () {
            return this.rolledUpHealthStatus?.find((status)=>status.healthStatus === HEALTH_STATUS_NEEDS_ATTENTION);
        },
        showRolledUpHealthStatus () {
            return this.rolledUpOnTrackWorkItems?.count || this.rolledUpAtRiskWorkItems?.count || this.rolledUpNeedsAttentionWorkItems?.count;
        },
        onTrackText () {
            return sprintf(n__('WorkItem|%{boldStart}%{count}%{boldEnd} item on track', 'WorkItem|%{boldStart}%{count}%{boldEnd} items on track', this.rolledUpOnTrackWorkItems.count), {
                count: this.rolledUpOnTrackWorkItems.count
            });
        },
        needsAttentionText () {
            return sprintf(n__('WorkItem|%{boldStart}%{count}%{boldEnd} item needs attention', 'WorkItem|%{boldStart}%{count}%{boldEnd} items need attention', this.rolledUpNeedsAttentionWorkItems.count), {
                count: this.rolledUpNeedsAttentionWorkItems.count
            });
        },
        atRiskText () {
            return sprintf(n__('WorkItem|%{boldStart}%{count}%{boldEnd} item at risk', 'WorkItem|%{boldStart}%{count}%{boldEnd} items at risk', this.rolledUpAtRiskWorkItems.count), {
                count: this.rolledUpAtRiskWorkItems.count
            });
        }
    }
};
